import { render } from "./ListePrivilege.vue?vue&type=template&id=728cf913&ts=true"
import script from "./ListePrivilege.vue?vue&type=script&lang=ts"
export * from "./ListePrivilege.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__